import { render, staticRenderFns } from "./ArticleWeekendField.vue?vue&type=template&id=95d5dd02&"
import script from "./ArticleWeekendField.vue?vue&type=script&lang=js&"
export * from "./ArticleWeekendField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports